module.exports = __webpack_public_path__ + "img/doc.1bf49552.png";